import { Fragment } from 'react'
import classnames from 'classnames/bind'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'

// Methods
import { helpCollectionPath, helpHomePath } from '../../methods'

// Types
import type { HelpBreadcrumb } from '@/api/fetchHelpArticle'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

type Props = {
  items: HelpBreadcrumb[]
  countryQuery?: string
}

const Breadcrumbs = ({ items, countryQuery }: Props) => {
  const { t } = useTranslation()

  return (
    <nav className={cx('help-breadcrumbs')} aria-label='breadcrumb'>
      <Link href={helpHomePath(countryQuery)}>{t('Footer_Help_Center')}</Link>
      {items.map((item) => (
        <Fragment key={item.id}>
          <span className={cx('help-breadcrumbs__sep')} aria-hidden>
            ›
          </span>
          <Link href={helpCollectionPath(item.id, countryQuery)}>{item.name}</Link>
        </Fragment>
      ))}
    </nav>
  )
}

export default Breadcrumbs
